var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntermediate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 32,
    viewBox: "0 0 72 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3125 26.7236L26.411 13.5545C26.1086 13.0504 25.469 12.8641 24.9432 13.127L23.9877 13.6048C23.7711 13.7131 23.5095 13.6706 23.3383 13.4994L18.8821 9.04314C18.4103 8.57141 17.6341 8.61149 17.2134 9.1292L5.625 23.3486V26.7236H34.3125Z",
    fill: "#DBEAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9876 13.6048C23.771 13.7131 23.5095 13.6707 23.3383 13.4994L23.1714 13.3325L19.3008 26.5657L19.8408 26.7237H20.4269L24.3115 13.4429L23.9876 13.6048Z",
    fill: "#C3DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.2861L18.497 8.79081C18.0567 8.61848 17.5328 8.73618 17.2134 9.12916L5.625 23.3486V26.7236H13.5V18.2861Z",
    fill: "#C3DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5977 16.102C17.1811 15.7398 16.5633 15.7333 16.1392 16.0867L13.5 18.2861L10.3606 16.9406C9.89044 16.7391 9.34348 16.8802 9.02946 17.2839L1.6875 26.7236H29.8125L17.5977 16.102Z",
    fill: "#C3DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3606 16.9406C9.89044 16.7391 9.34348 16.8802 9.02946 17.284L1.6875 26.7236H17.4375L13.5 18.2861L10.3606 16.9406Z",
    fill: "#A4CCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3606 16.9406C9.89044 16.7391 9.34348 16.8802 9.02946 17.284L1.6875 26.7236H6.1875L11.3798 17.3775L10.3606 16.9406Z",
    fill: "#8BB3EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4375 27.2861H0.5625C0.251578 27.2861 0 27.0343 0 26.7236C0 26.413 0.251578 26.1611 0.5625 26.1611H35.4375C35.7484 26.1611 36 26.413 36 26.7236C36 27.0343 35.7484 27.2861 35.4375 27.2861Z",
    fill: "#C3DDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 26.7236L62.411 13.5545C62.1086 13.0504 61.469 12.8641 60.9432 13.127L59.9877 13.6048C59.7711 13.7131 59.5095 13.6706 59.3383 13.4994L54.8821 9.04314C54.4103 8.57141 53.6341 8.61149 53.2134 9.1292L41.625 23.3486V26.7236H70.3125Z",
    fill: "#DBEAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9876 13.6048C59.771 13.7131 59.5095 13.6707 59.3383 13.4994L59.1714 13.3325L55.3008 26.5657L55.8408 26.7237H56.4269L60.3115 13.4429L59.9876 13.6048Z",
    fill: "#C3DDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 18.2861L54.497 8.79081C54.0567 8.61848 53.5328 8.73618 53.2134 9.12916L41.625 23.3486V26.7236H49.5V18.2861Z",
    fill: "#C3DDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5977 16.102C53.1811 15.7398 52.5633 15.7333 52.1392 16.0867L49.5 18.2861L46.3606 16.9406C45.8904 16.7391 45.3435 16.8802 45.0295 17.2839L37.6875 26.7236H65.8125L53.5977 16.102Z",
    fill: "#C3DDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3606 16.9406C45.8904 16.7391 45.3435 16.8802 45.0295 17.284L37.6875 26.7236H53.4375L49.5 18.2861L46.3606 16.9406Z",
    fill: "#A4CCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3606 16.9406C45.8904 16.7391 45.3435 16.8802 45.0295 17.284L37.6875 26.7236H42.1875L47.3798 17.3775L46.3606 16.9406Z",
    fill: "#8BB3EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4375 27.2861H36.5625C36.2516 27.2861 36 27.0343 36 26.7236C36 26.413 36.2516 26.1611 36.5625 26.1611H71.4375C71.7484 26.1611 72 26.413 72 26.7236C72 27.0343 71.7484 27.2861 71.4375 27.2861Z",
    fill: "#C3DDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/intermediate.096730e5.svg";
export { ForwardRef as ReactComponent };